<template>
  <div class="card" v-if="paginationUser">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-row form-group">
            <label class="col-md-3 col-form-label">Employee ID</label>
            <div class="col-md-8">
              <input
                v-model="filterUser.employee_id"
                type="text"
                placeholder="Employee ID"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-row form-group">
            <label class="col-md-3 col-form-label">Name</label>
            <div class="col-md-8">
              <input
                v-model="filterUser.name"
                type="text"
                placeholder="Name"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-row form-group">
            <label class="col-md-3 col-form-label">E-Mail</label>
            <div class="col-md-8">
              <input
                v-model="filterUser.email"
                type="text"
                placeholder="E-Mail"
                class="form-control"
              />
              <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-row form-group">
            <label class="col-md-3 col-form-label">Open ID</label>
            <div class="col-md-8">
              <input
                v-model="filterUser.open_id"
                type="text"
                placeholder="Open ID"
                class="form-control"
              />
              <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-row form-group">
            <label class="col-md-3 col-form-label">Status</label>
            <div class="col-form-label row" style="margin-left: 0px">
              <b-form-checkbox
                @change="onUserSelectAllStatus($event)"
                class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                style="margin-right: 10px"
                name="status_all"
                id="status_all"
                v-model="isUserSelectAllStatus"
                >All</b-form-checkbox
              >
              <b-form-checkbox
                v-model="filterUser.status"
                value="Active"
                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-3"
                style="margin-right: 10px"
                name="active"
                id="active"
                >Active</b-form-checkbox
              >
              <b-form-checkbox
                v-model="filterUser.status"
                value="Inactive"
                class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-3"
                style="margin-right: 10px"
                name="inactive"
                id="inactive"
                >Inactive</b-form-checkbox
              >
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12 text-sm-right">
              <div class="button-items">
                <button
                  type="button"
                  class="btn btn-primary btn-sm waves-effect"
                  @click="onFilterUser()"
                >
                  <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                  Search
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm waves-effect"
                  @click="onUserClear()"
                >
                  <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="showDataTable">
        <div class="col-sm-12 col-md-6 margin-center-auto">
          <h6 v-if="isPagingUser" class="mb-0">
            <small class="text-muted">Result </small>
            {{ paginationUser.totalRecords === 0 ?  0 : (pageNo - 1) * paginationUser.pageSize + 1 }}
            -
            {{
              pageNo * paginationUser.pageSize > paginationUser.totalRecords
                ? paginationUser.totalRecords
                : pageNo * paginationUser.pageSize
            }}
            <small class="text-muted">From</small>
            {{ paginationUser.totalRecords }}
            <small class="text-muted">Records</small>
          </h6>
        </div>
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-right">
            <label class="d-inline-flex align-items-center"> Size </label>
            <label class="d-inline-flex align-items-center">
              <b-form-select
                v-model="paginationUser.pageSize"
                size="sm"
                :options="pageOptions"
                @change="onFilterUser()"
              ></b-form-select></label
            ><label class="d-inline-flex align-items-center"> Records </label>
            <label class="d-inline-flex align-items-center">
              <b-form-input
                v-model="searchUser"
                type="search"
                :placeholder="`Search in page ${pageNo} `"
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" ></loading>

      <div v-if="isUserSelected" class="row">
        <div class="col-sm-12 col-md-12 margin-center-auto">
          <!-- {{ selectAttributeOptions }} -->
          <b-card
            header-class="bg-transparent border-primary"
            class="border border-primary"
          >
            <p class="card-text text-center">
              <b-dropdown
                class="btn-group mr-2 mb-2 mb-sm-0"
                ref="ddown_attribute"
                variant="primary"
              >
                <template slot="button-content">
                  Add Attributes
                  <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
                </template>
                <b-dropdown-group
                  v-show="isSideBarDefaultParameterOptions"
                  id="dropdown-group-1"
                  header="Default"
                >
                  <b-dropdown-form>
                    <template v-for="(value, key) in sideBarDefaultParameterOptions">
                      <div :key="key">
                        <label>
                          {{ key }}
                        </label>
                        <b-form-checkbox
                          class=""
                          v-for="(item, subIndex) in value"
                          :key="`${item}-${subIndex}`"
                          :value="{
                            key: key,
                            value: item,
                          }"
                          v-model="sideBarSelectAttributesOptions"
                          >{{ item }}</b-form-checkbox
                        >
                        <hr />
                      </div>
                    </template>
                  </b-dropdown-form>
                </b-dropdown-group>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-group id="dropdown-group-1" header="Custom">
                  <b-dropdown-form>
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label-size="sm"
                      label="Key"
                      label-for="input-sm"
                      style="margin-bottom: 0"
                    >
                      <b-form-input
                        id="dropdown-form-attribute"
                        v-model="sideBarNewAttributeKeyOption"
                        size="sm"
                        placeholder="business_unit_name"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label-size="sm"
                      label="value"
                      label-for="input-sm"
                      style="margin-bottom: 0"
                    >
                      <b-form-input
                        id="dropdown-form-attribute"
                        v-model="sideBarNewAttributeValueOption"
                        size="sm"
                        placeholder="OFM"
                      ></b-form-input>
                    </b-form-group>
                    <label class="text-sm text-link" @click="onNewAttributeOption"
                      >Create new</label
                    >
                  </b-dropdown-form>
                </b-dropdown-group>
                <b-dropdown-divider></b-dropdown-divider>
                <label
                  class="text-link text-center width-15rem"
                  @click="onApplyAttributes"
                  >Apply</label
                >
              </b-dropdown>
              <label v-if="$validate.anyArrayObjectValid(sideBarApplySelectAttributeOptions)">
                attributes selected:
                <span
                  class="badge badge-pill badge-soft-primary font-size-11 mr-03rem"
                  v-for="(group, key) in groupApplySelectAttributeOptions"
                  :key="key"
                >
                  <b style="font-size: small">{{ key }}</b
                  >:
                  {{ group.map((s) => s.value).join(", ") }}
                </span>
              </label>
            </p>
          </b-card>
        </div>
      </div>
      <div class="row" v-if="showDataTable">
        <div class="col-md-12">
          <div class="table-responsive">
            <b-table
              class="table table-centered table-nowrap"
              ref="usertable"
              :empty-text="'Not found any result'"
              :show-empty="!isPagingUser"
              :bordered="true"
              :filter="searchUser"
              :filter-included-fields="['email']"

              :items="formattedUsers"
              align="center"
              v-bind:fields="userTablefields"
              :perPage="paginationUser.pageSize"
            >
              <template v-slot:cell(id)="data">
                <div class="text-right">
                  <b-form-checkbox
                    v-if="!disabledGroupUsers(data.value)"
                    v-model="sideBarUserSelected"
                    :value="{
                      id: data.value,
                      reference_id: data.item.reference_id,
                      info: data.item.info,
                    }"
                    class="custom-checkbox-info mb-3"
                  ></b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge v-if="data.value === 'Active'" variant="success">
                  {{ data.value }}
                </b-badge>
                <b-badge v-else variant="danger">
                  {{ data.value }}
                </b-badge>
              </template>
            </b-table>
          </div>
        </div>
        <div class="col-lg-4">
          <h6 class="mb-0">
            <small class="text-muted">Result</small>
            {{paginationUser.totalRecords === 0 ?  0 : (pageNo - 1) * paginationUser.pageSize + 1 }}
            -
            {{
              pageNo * paginationUser.pageSize > paginationUser.totalRecords
                ? paginationUser.totalRecords
                : pageNo * paginationUser.pageSize
            }}
            <small class="text-muted">From</small>
            {{ paginationUser.totalRecords }}
            <small class="text-muted">Records</small>
          </h6>
        </div>
        <div class="col-lg-8">
          <b-pagination

            :total-rows="paginationUser.totalRecords"
            :per-page="paginationUser.pageSize"
            v-model="pageNo"
            @change="onClickUserPagination($event)"
            class="pagination pagination-rounded justify-content-end mb-2"
          />
        </div>
      </div>
      <div class="row" v-if="isPagingBottomUser"></div>
      <div class="row">
        <div class="col-md-6">
          <label id="hover-text">
            User to selected <b>({{ sideBarUserSelected.length }})</b>
          </label>
          <b-tooltip
            target="hover-text"
            :title="sideBarUserSelected.map((q) => q.email).join('\n')"
            custom-class="custom-tooltip"
          ></b-tooltip>
        </div>
        <div class="col-lg-6 text-sm-right">
          <div class="button-items">
            <button
              v-show="$validate.anyArrayObjectValid(sideBarUserSelected) && isApply"
              type="button"
              class="btn btn-primary"
              @click="onApplyAddUserClick()"
            >
              Apply
            </button>
            <button
              ref="hideUser"
              type="button"
              class="btn btn-secondary"
              @click="onHide"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import groupService from "@/helpers/service/group-provider";
import userService from "@/helpers/service/user-provider";
import serviceService from "@/helpers/service/service-provider";
import { eventBus } from "@/main.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { userComputed, userMethods, applicationComputed } from "@/state/helpers";

export default {
  props: {
    applicationId: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
    groupUsers: {
      type: Array,
      default: () => [],
    },
  },
  components: {Loading },

  data() {
    return {
      showDataTable:false,
      isLoading:false,
      filterUser: {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: [],
      },
      searchUser: null,
      isUserSelectAllStatus: true,
      userSelectAllStatus: ["Active", "Inactive"],
      isUserSelectAllGroup: true,
      userSelectAllGroup: ["SuperUser", "Admin"],
      paginationUser: {
        totalRecords: 0,
        pageSize: 10,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageNo: 1,
      pageOptions: [5, 10, 25, 50, 100],
      userTablefields: [
        {
          key: "id",
          label: "Select",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
      ],
      sideBarUserSelected: [],
      sideBarUsersDefaultSelected: [],
      sideBarDefaultParameterOptions: {},
      sideBarTempDefaultParameterOptions: {},
      sideBarNewAttributeKeyOption: "",
      sideBarNewAttributeValueOption: "",
      sideBarSelectAttributesOptions: [],
      sideBarApplySelectAttributeOptions: [],
      isSideBarDefaultParameterOptions: false,
    };
  },
  computed: {
    ...userComputed,
    ...applicationComputed,
    formattedUsers() {
    return this.paginationUser?.items?.map(user => ({
      ...user,
      email: user.info.email, // Create a direct `email` field
    }));
  },
    isApply: function () {
      if (this.$validate.anyArrayObjectValid(this.sideBarUserSelected))
        return (
          this.sideBarUserSelected.filter((q) => !this.sideBarUsersDefaultSelected.includes(q.id))
            .length > 0
        );
      return false;
    },
    isPagingUser() {
      return this.$validate.anyArrayObjectValid(this.paginationUser.items);
    },
    isPagingBottomUser() {
      return (
        this.$validate.anyArrayObjectValid(this.paginationUser.items) &&
        this.paginationUser.pageSize > 5 &&
        this.paginationUser.items.length > 5
      );
    },
    isUserSelected() {
      return this.$validate.anyArrayObjectValid(this.sideBarUserSelected);
    },
    groupApplySelectAttributeOptions() {
      return this.sideBarApplySelectAttributeOptions.reduce((groups, item) => {
        const key = item.key;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    },
  },
  watch: {
    "filterUser.status": {
      handler() {
        this.isUserSelectAllStatus =
          this.filterUser.status.length === this.userSelectAllStatus.length;
      },
      deep: true,
    },
    isUserSelectAllStatus: {
      handler(newVal) {
        if (newVal) {
          this.filterUser.status = ["Active", "Inactive"];
        }
      },
      immediate: true,
    },
    "filterUser.groups": {
      handler() {
        this.isUserSelectAllGroup =
          this.filterUser.groups.length === this.userSelectAllGroup.length;
      },
      deep: true,
    },
    'sideBarDefaultParameterOptions': {
      handler(newVal) {
        // React to changes in the deep sub-model
        this.isSideBarDefaultParameterOptions = this.$validate.isObjectValid(newVal);
      },
      deep: true, // Enable deep watching
    },
    GET_FILTER_USER(val, oldVal) {
      this.filterUser = Object.assign({}, val);
    },
  },
  mounted: function () {
    this.onDefaultAttributes();
    // this.filterUser = Object.assign({}, this.GET_FILTER_USER);
  },
  methods: {
    ...userMethods,
    onApplyAttributes() {
      console.log('onApplyAttributes',this.sideBarSelectAttributesOptions);
      
      this.sideBarApplySelectAttributeOptions = this.sideBarSelectAttributesOptions;
      this.$refs.ddown_attribute.visible = false;
    },
    onNewAttributeOption() {
      const trimmedKey = this.sideBarNewAttributeKeyOption.trim();
      const trimmedValue = this.sideBarNewAttributeValueOption.trim();
      if (this.$validate.isValid(trimmedKey) && this.$validate.isValid(trimmedValue)) {
        if (this.$validate.isObjectKeyValid(this.sideBarDefaultParameterOptions, trimmedKey)) {
          this.sideBarDefaultParameterOptions[trimmedKey].push(trimmedValue);
        } else {
          this.sideBarDefaultParameterOptions[trimmedKey] = [trimmedValue];
        }
      }

      this.sideBarNewAttributeKeyOption = "";
      this.sideBarNewAttributeValueOption = "";
      this.isSideBarDefaultParameterOptions  = this.$validate.isObjectValid(
        this.sideBarDefaultParameterOptions
      );
    },
    async onDefaultAttributes() {
      try {
        const result = await serviceService.getApplicationServiceParameterOptionsAsync(
          this.applicationId
        );
        if (result.status === 200) {
          const data = result.data;
          if (this.$validate.isObjectValid(data)) {
            this.sideBarDefaultParameterOptions = data;
            this.sideBarTempDefaultParameterOptions = { ...data };
          }
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      } catch (error) {
        console.error("Error fetching default attributes:", error);
      }
    },
    onUserSelectAllStatus(event) {
      this.filterUser.status = event ? this.userSelectAllStatus : [];
    },
    onUserSelectAllGroup(event) {
      this.filterUser.groups = event ? this.userSelectAllGroup : [];
    },
    async onFilterUser() {
      this.isLoading = true;
      this.showDataTable = false;
      this.pageNo = 1;
      let params = new URLSearchParams();
      params.append("pageSize", this.paginationUser.pageSize);
      params.append("page", this.pageNo);

      params.append("open_id", this.filterUser.open_id.trim() || "");
      params.append("employee_id", this.filterUser.employee_id.trim() || "");
      params.append("name", this.filterUser.name.trim() || "");
      params.append("email", this.filterUser.email.trim() || "");
      // params.append("channel_type", "AD");

      if (!this.isUserSelectAllStatus) {
        params.append("status", this.filterUser.status);
      }

      // this.sideBarUserSelected = [];
      this.sideBarUsersDefaultSelected = [];
      try {
        let result = await userService.getUsersAsync(params);
        if (result.status === 200) {
          this.isLoading = false;

          this.paginationUser = result.data;
          // console.log(this.paginationUser.items);
          let emailsSelected = this.groupUsers.map((el) => el.id);

          if (this.isPagingUser) {
            let sideBarUsersDefaultSelected = this.paginationUser.items.filter((q) =>
              emailsSelected.includes(q.id)
            );
            if (
              this.$validate.anyArrayObjectValid(sideBarUsersDefaultSelected) &&
              this.$validate.anyArrayObjectValid(this.sideBarUserSelected)
            ) {
              this.sideBarUsersDefaultSelected = sideBarUsersDefaultSelected.map((el) => el.id);
              this.sideBarUserSelected.push(...this.sideBarUsersDefaultSelected.map((q) => q.id));
            }
          }       
           this.showDataTable = true;

        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
        this.ADD_FILTER_USER(this.filterUser);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },
    async onClickUserPagination(pageNo) {
      this.isLoading = true
      this.showDataTable = false
      this.pageNo = pageNo;
      let params = new URLSearchParams();
      params.append("pageSize", this.paginationUser.pageSize);
      if (this.pageNo > 0) params.append("page", this.pageNo);

      params.append("open_id", this.filterUser.open_id.trim() || "");
      params.append("employee_id", this.filterUser.employee_id.trim() || "");
      params.append("name", this.filterUser.name.trim() || "");
      params.append("email", this.filterUser.email.trim() || "");

      if (!this.isUserSelectAllStatus) {
        params.append("status", this.filterUser.status);
      }

      this.sideBarUsersDefaultSelected = [];
      try {
        let result = await userService.getUsersAsync(params);
        if (result.status === 200) {
          this.isLoading = false

          this.paginationUser = result.data;
          if (this.isPagingUser) {
            let emailsSelected = this.groupUsers.map((el) => el.id);
            let sideBarUsersDefaultSelected = this.paginationUser.items.filter((q) =>
              emailsSelected.includes(q.id)
            );
            if (
              this.$validate.anyArrayObjectValid(sideBarUsersDefaultSelected) &&
              this.$validate.anyArrayObjectValid(this.sideBarUserSelected)
            ) {
              this.sideBarUsersDefaultSelected = sideBarUsersDefaultSelected.map((el) => el.id);
              this.sideBarUserSelected.push(...this.sideBarUsersDefaultSelected.map((q) => q.id));
            }
          }
          this.showDataTable = true
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
        this.ADD_FILTER_USER(this.filterUser);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },
    async onApplyAddUserClick() {
      this.isLoading = true
      let sideBarUserSelected = this.sideBarUserSelected.filter(
        (q) => !this.sideBarUsersDefaultSelected.includes(q.id)
      );
      if (!this.$validate.anyArrayObjectValid(sideBarUserSelected)) return;

      let applyAttributes = {};
      for (let i = 0; i < this.sideBarApplySelectAttributeOptions.length; i++) {
        let obj = this.sideBarApplySelectAttributeOptions[i];
        // if (!this.$validate.anyArrayObjectValid(obj.value)) continue;
        if (this.$validate.isObjectKeyValid(applyAttributes, obj.key)) {
          applyAttributes[obj.key].push(obj.value);
        } else {
          applyAttributes[obj.key] = [obj.value];
        }
      }

      let update = {
        users: sideBarUserSelected,
        attribute: applyAttributes,
      };

      let result = await groupService.updateGroupAsync(
        this.applicationId,
        this.groupId,
        update
      );

      if (result.status === 204) {
        this.isLoading = false

        this.$utils.notification("success", "Success", 1500);
        this.$refs.hideUser.click();
        await this.$emit("getGroupUsersSelected", this.groupId);
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else if (result.response.status === 412) {
        if (
          this.$validate.containsKey(result.response.data, "users") &&
          this.$validate.anyArrayObjectValid(result.response.data.users.errors)
        ) {
          this.$utils.notification(
            "error",
            result.response.data.users.errors[0].errorMessage,
            3000
          );
        }
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    onHide() {
      this.onClearData();
      this.$emit("hide");
    },
    onClearData() {
      this.filterUser=  {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: ["Active", "Inactive"]
      },
      this.showDataTable = false
      this.pageNo = 1;
      this.paginationUser = {
        totalRecords: 0,
        pageSize: 10,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      };
      this.sideBarUserSelected = [];
      this.sideBarUsersDefaultSelected = [];
      this.sideBarNewAttributeKeyOption = "";
      this.sideBarNewAttributeValueOption = "";
      this.sideBarSelectAttributesOptions = [];
      this.sideBarApplySelectAttributeOptions = [];
      this.sideBarDefaultParameterOptions = { ...this.sideBarTempDefaultParameterOptions };
    },
    onUserClear() {
      this.filterUser = {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: [],
      };
    },
    disabledGroupUsers(id) {
      return this.groupUsers.filter((q) => q.id === id).length > 0;
    },
  },
};
</script>
<style scope>
.margin-center-auto {
  margin: auto;
}
.text-clear-all {
  color: #7475d2;
  cursor: pointer;
}
.dropdown-header {
  padding: 4px 5px 0 5px;
}
.b-dropdown-form {
  padding: 4px 15px 0 15px;
}
.list-unstyled {
  margin-left: 0;
}
.text-sm {
  font-size: 0.7rem;
}
.text-link {
  color: #7475d2;
  cursor: pointer;
}
.width-15rem {
  width: 15rem;
}
.dropdown-menu {
  min-width: 1rem !important;
}
.mr-03rem {
  margin-right: 0.3rem;
}
.card-body {
  padding: 0.5rem;
}
.custom-tooltip > .tooltip-inner {
  max-width: 400px !important;
  text-align: left;
}
</style>
